export default "__VITE_ASSET__CMv03QYQ__"